import { render, staticRenderFns } from "./Scale.vue?vue&type=template&id=1c8f02dd&scoped=true&"
import script from "./Scale.vue?vue&type=script&lang=js&"
export * from "./Scale.vue?vue&type=script&lang=js&"
import style0 from "./Scale.vue?vue&type=style&index=0&id=1c8f02dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8f02dd",
  null
  
)

export default component.exports